// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArgonInputGroupController from "./argon_input_group_controller"
application.register("argon-input-group", ArgonInputGroupController)

import BsPopoverController from "./bs_popover_controller"
application.register("bs-popover", BsPopoverController)

import BsTooltipController from "./bs_tooltip_controller"
application.register("bs-tooltip", BsTooltipController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConfigOptionFormController from "./config_option_form_controller"
application.register("config-option-form", ConfigOptionFormController)

import ContractFormController from "./contract_form_controller"
application.register("contract-form", ContractFormController)

import CopyController from "./copy_controller"
application.register("copy", CopyController)

import DashboardWidgetsController from "./dashboard_widgets_controller"
application.register("dashboard-widgets", DashboardWidgetsController)

import DateFormatterController from "./date_formatter_controller"
application.register("date-formatter", DateFormatterController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DiscountController from "./discount_controller"
application.register("discount", DiscountController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import FormActionsController from "./form_actions_controller"
application.register("form-actions", FormActionsController)

import ImportModalController from "./import_modal_controller"
application.register("import-modal", ImportModalController)

import InvitationRequestController from "./invitation_request_controller"
application.register("invitation-request", InvitationRequestController)

import JsonViewerController from "./json_viewer_controller"
application.register("json-viewer", JsonViewerController)

import LicensesController from "./licenses_controller"
application.register("licenses", LicensesController)

import ModalVisibilityController from "./modal_visibility_controller"
application.register("modal-visibility", ModalVisibilityController)

import ModalsController from "./modals_controller"
application.register("modals", ModalsController)

import PeaqTableController from "./peaq_table_controller"
application.register("peaq-table", PeaqTableController)

import PriceVersionTrackController from "./price_version_track_controller"
application.register("price-version-track", PriceVersionTrackController)

import ProfileFormController from "./profile_form_controller"
application.register("profile-form", ProfileFormController)

// NOTE: the "public-contact" controller is intentionally NOT registered here. It pulls in
// google-libphonenumber (~570 KB) and is needed only on the public /contact page, so it lives in
// its own bundle (app/javascript/public_contact.js) to keep that weight out of application.js. Do
// not re-add it here — see that file. (It sits outside app/javascript/controllers/ so
// `rails stimulus:manifest:update` won't regenerate an import for it.)

import QuillEditorController from "./quill_editor_controller"
application.register("quill-editor", QuillEditorController)

import Quotes__BundleArrayCountController from "./quotes/bundle_array_count_controller"
application.register("quotes--bundle-array-count", Quotes__BundleArrayCountController)

import Quotes__LicenseConfigRowController from "./quotes/license_config_row_controller"
application.register("quotes--license-config-row", Quotes__LicenseConfigRowController)

import QuotesByQuarterChartController from "./quotes_by_quarter_chart_controller"
application.register("quotes-by-quarter-chart", QuotesByQuarterChartController)

import RadioCardsController from "./radio_cards_controller"
application.register("radio-cards", RadioCardsController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import StorageArrayFormController from "./storage_array_form_controller"
application.register("storage-array-form", StorageArrayFormController)

import MarkdownPreviewController from "./markdown_preview_controller"
application.register("markdown-preview", MarkdownPreviewController)

import MarkdownToolbarController from "./markdown_toolbar_controller"
application.register("markdown-toolbar", MarkdownToolbarController)

import TrialLicensesController from "./trial_licenses_controller"
application.register("trial-licenses", TrialLicensesController)

import UserFormController from "./user_form_controller"
application.register("user-form", UserFormController)

import UserSettingsController from "./user_settings_controller"
application.register("user-settings", UserSettingsController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
